import React from 'react';
import CategoriesList from '../../components/Category/CategoriesList';
import CategoryStreams from '../../components/Category/CategoryStreams';
import styles from './CategoryBrowser.module.css';
import Streaming from '../../components/Streaming';
import {useCategoryParams} from '../../hooks/useCategoryParams';

function CategoryBrowser() {
    const [params, actions] = useCategoryParams();

    const handleCloseStreams = () => {
        actions.clearCategoryId();
    };

    // Determine what to show based on screen size and state
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
    const showStreamsInLeftPanel = params.categoryId && isMobile;
    const showCategoriesInLeftPanel = !params.categoryId || !isMobile;
    const showStreamsInMiddlePanel = params.categoryId && !isMobile;

    return (
        <div className={styles.boxcontainer}>
            {/* Left panel - Categories or Streams (mobile) */}
            {(showCategoriesInLeftPanel || showStreamsInLeftPanel) && (
                <div className={styles.box}>
                    {showStreamsInLeftPanel ? (
                        <CategoryStreams onClose={handleCloseStreams} />
                    ) : (
                        <CategoriesList />
                    )}
                </div>
            )}

            {/* Middle panel - Streams (desktop) */}
            {showStreamsInMiddlePanel && (
                <div className={styles.box}>
                    <CategoryStreams onClose={handleCloseStreams} />
                </div>
            )}

            {/* Right panel - Streaming */}
            <div className={`${styles.box} ${!showStreamsInMiddlePanel ? styles.expanded : ''}`}>
                <Streaming />
            </div>
        </div>
    );
}

export default CategoryBrowser;